<div class="bloque-de-bienvenida-section">
  <div class="login d-flex justify-content-center align-items-center vh-100">
    <div class="col-md-6">
      <form [formGroup]="loginForm" (ngSubmit)="login()" class="custom-form text-center">
        <img class="bloque-de-bienvenida-img w-100" [src]="rutaImagen" alt="">
        <input
          type="text"
          formControlName="username"
          placeholder="Usuario"
          class="form-control my-2"
        />
        <div *ngIf="loginForm.get('username').touched && loginForm.get('username').invalid" class="text-danger d-flex justify-content-start">
          El nombre de usuario es requerido.
        </div>
        <input
          type="password"
          formControlName="password"
          placeholder="Contraseña"
          class="form-control my-2"
        />
        <div *ngIf="loginForm.get('password').touched && loginForm.get('password').invalid" class="text-danger d-flex justify-content-start">
          La contraseña es requerida.
        </div>
        <button type="submit" class="btn btn-success w-100">
          Iniciar sesión
        </button>
        <div *ngIf="errorMessage" class="text-danger mt-2">
          {{ errorMessage }}
        </div>
      </form>


      <!-- <button class="btn btn-success w-100" (click)="verificarAutenticacion()">VERIFICAR AUTENTIFICACIÓN</button> -->
    </div>
  </div>
</div>

